import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { h6, uppercase } from 'scy/text/styles.mod.scss';
import { right } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import styles from './styles.mod.scss';

export default function ProductsHeader({ title, url }) {
  if (!url || !title) return null;
  return (
    <div className={styles.container}>
      {url && (
        <Link
          className={classnames(h6, uppercase, right, padding.bottom_sm)}
          to={url.indexOf('/') === 0 ? url : '/' + url}
        >
          View All
        </Link>
      )}
      <Link to={url.indexOf('/') === 0 ? url : '/' + url}>
        <h2 className={styles.title}>{title}</h2>
      </Link>
    </div>
  );
}
